import React from 'react';
import { IconProps } from './model/IconInterface';

const ChartLineIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M3 3v18h18" /><polyline points="7 14 11 10 14 13 20 7" />
    </svg>
  );
};

export default ChartLineIcon;
